import { render, staticRenderFns } from "./PieChartStops.vue?vue&type=template&id=0f642e1a&"
import script from "./PieChartStops.vue?vue&type=script&lang=js&"
export * from "./PieChartStops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports